import React from 'react';
import { InfinityIcon } from 'lucide-react';

/**
 * Gold medallion stamped on every pack. Treated like a graded-card seal: the
 * lifetime replacement is the single most valuable thing in the offer, so it
 * gets a physical-looking object rather than another line of text.
 */
export function GoldMedal({
  className = '',
  size = 108
}: {
  className?: string;
  size?: number;
}) {
  return <span className={`pointer-events-none inline-flex select-none items-center justify-center rounded-full ${className}`} style={{
    width: size,
    height: size,
    backgroundImage: 'conic-gradient(from 210deg, #7a5a12, #d4a017, #ffe79a, #f2c94c, #b8860b, #fff3c4, #c8951b, #7a5a12)',
    boxShadow: '0 0 0 2px rgba(255,231,154,0.55), 0 18px 40px -16px rgba(212,160,23,0.85), inset 0 2px 6px rgba(255,255,255,0.45)'
  }} role="img" aria-label="Lifetime Replacement Warranty" data-id="element-638" data-mp="3kwek16dix3h7">
      <span className="flex h-[86%] w-[86%] flex-col items-center justify-center rounded-full text-center" style={{
      background: 'radial-gradient(circle at 30% 25%, #2a2008 0%, #140f04 70%)',
      boxShadow: 'inset 0 0 0 1px rgba(242,201,76,0.6)'
    }} data-id="element-639" data-mp="2x6tpdq80chs3">
        <InfinityIcon className="text-[#ffe79a]" style={{
        width: size * 0.3,
        height: size * 0.3
      }} aria-hidden="true" data-id="element-640" data-mp="4cjhpryomp33" />
        <span className="mt-0.5 font-display font-extrabold uppercase leading-none tracking-[0.14em] gold-text" style={{
        fontSize: Math.max(9, size * 0.11)
      }} data-id="element-641" data-mp="37t9xuznzaiii">
          Lifetime
        </span>
        <span className="font-display font-bold uppercase leading-tight tracking-[0.1em] text-[#f2c94c]" style={{
        fontSize: Math.max(7, size * 0.075)
      }} data-id="element-642" data-mp="3hq4sv8l1m0s1">
          Replacement
        </span>
      </span>
    </span>;
}

/** Gold pill for tight spots. */
export function LifetimeSeal({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-2 gold-plate px-3 py-1.5 font-display text-sm font-extrabold uppercase tracking-wide text-ink-950 shadow-[0_10px_30px_-14px_rgba(212,160,23,0.8)] ${className}`} data-id="element-643" data-mp="2y2ewu1jhfs53">
      <InfinityIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-644" data-mp="372l435ol7vvt" />
      Lifetime replacement
    </span>;
}

/** Compact gold line used inside the pack "what's in the box" lists. */
export function LifetimeLine({
  label,
  className = ''
}: {
  label: string;
  className?: string;
}) {
  return <span className={`flex items-start gap-2.5 border gold-edge bg-[#1a1408] px-3 py-2.5 text-[15px] font-bold text-[#ffe79a] ${className}`} data-id="element-645" data-mp="2aeeue4ct6dao">
      <InfinityIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#f2c94c]" aria-hidden="true" data-id="element-646" data-mp="2o6l9dn486e8j" />
      {label}
    </span>;
}